(() => {
  const CODE = 'NADEL89';
  const GIFT_VARIANT_ID = 55249738891639;
  const THRESHOLD_CENTS = 8900;
  const PROPERTY_KEY = '_makema_newsletter_gift';
  const ENTITLEMENT_ATTRIBUTE = '_makema_newsletter_gift_entitled';
  let syncing = false;

  const hasCode = (cart) => (cart.discount_codes || []).some((entry) => String(entry.code || '').toUpperCase() === CODE);
  const hasEntitlement = (cart) => cart.attributes?.[ENTITLEMENT_ATTRIBUTE] === CODE;
  const giftLines = (cart) => (cart.items || []).filter((item) => item.variant_id === GIFT_VARIANT_ID && item.properties?.[PROPERTY_KEY] === CODE);
  const eligibleSubtotal = (cart) => (cart.items || []).reduce((sum, item) => {
    if (item.variant_id === GIFT_VARIANT_ID && item.properties?.[PROPERTY_KEY] === CODE) return sum;
    return item.requires_shipping ? sum + item.final_line_price : sum;
  }, 0);

  const sections = () => {
    const list = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: list } }));
    return [...new Set(list)].slice(0, 5);
  };

  async function mutate(path, payload) {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...payload, sections: sections() })
    });
    if (!response.ok) throw new Error(`Newsletter gift cart update failed: ${response.status}`);
    return response.json();
  }

  async function sync(sourceCart) {
    if (syncing) return;
    syncing = true;
    try {
      const cart = sourceCart || await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } }).then((response) => response.json());
      const lines = giftLines(cart);
      const eligible = hasEntitlement(cart) && hasCode(cart) && eligibleSubtotal(cart) >= THRESHOLD_CENTS;
      let updated;

      if (eligible && lines.length === 0) {
        await mutate('cart/add.js', { items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: { [PROPERTY_KEY]: CODE } }] });
        const root = window.Shopify?.routes?.root || '/';
        window.location.assign(`${root}discount/${CODE}?redirect=${encodeURIComponent(`${root}cart`)}`);
        return;
      } else if (eligible && (lines.length > 1 || lines[0].quantity !== 1)) {
        const updates = Object.fromEntries(lines.map((line, index) => [line.key, index === 0 ? 1 : 0]));
        updated = await mutate('cart/update.js', { updates });
      } else if (!eligible && lines.length > 0) {
        updated = await mutate('cart/update.js', { updates: Object.fromEntries(lines.map((line) => [line.key, 0])) });
      }

      if (updated && window.theme?.pubsub) {
        window.theme.pubsub.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'makema-newsletter-gift', cart: updated });
      } else if (updated) {
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
      }
    } catch (error) {
      console.error(error);
    } finally {
      syncing = false;
    }
  }

  async function activateFromNewsletterLink() {
    const url = new URL(window.location.href);
    if (String(url.searchParams.get('makema_gift') || '').toUpperCase() !== CODE) return null;

    const cart = await mutate('cart/update.js', { attributes: { [ENTITLEMENT_ATTRIBUTE]: CODE } });
    url.searchParams.delete('makema_gift');
    window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
    return cart;
  }

  document.addEventListener('DOMContentLoaded', async () => {
    try {
      const activatedCart = await activateFromNewsletterLink();
      await sync(activatedCart);
    } catch (error) {
      console.error(error);
    }
    if (window.theme?.pubsub) {
      window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source !== 'makema-newsletter-gift') sync(event.cart);
      });
    }
  });
})();